import { ROUTES } from 'src/enums';

export default [
  {
    path: '/my',
    redirect: '/my/bookshelf',
  },
  {
    path: '/my/bookshelf',
    component: () => import('layouts/SpaLayout.vue'),
    meta: { auth: true },
    children: [
      {
        path: '',
        component: () => import('layouts/SubdomainLayout.vue'),
        children: [
          {
            path: '',
            name: ROUTES.MY.BOOK,
            meta: { auth: true },
            component: () => import('pages/my/SubdomainMyPage.vue'),
          },
          {
            path: 'profile',
            name: ROUTES.MY.PROFILE,
            meta: { auth: true },
            component: () => import('pages/my/SubdomainMyProfilePage.vue'),
          },
        ],
      },
    ],
  },
];
